export default "/images/a8a00933f1989b2e0f0a49b95dcfaea6.avif";